import { Route } from '@angular/router';
import {
    FlatbedDemand,
    FlatbedNational,
    IqBuilderDashboardComponent,
    ReeferDemand,
    ReeferNational,
    VanDemand,
    VanNational,
    ViewTrendsDashboard
} from '@dat/iq-builder';
import { IqCarrierResourcesDashboardComponent } from '@dat/iq-carrier-resources';

export const remoteRoutes: Route[] = [
    {
        path: 'trendlines',
        component: IqBuilderDashboardComponent,
        data: { dashboard: ViewTrendsDashboard },
    },
    {
        path: 'trendlines/van/demand-and-capacity',
        component: IqBuilderDashboardComponent,
        data: { dashboard: VanDemand },
    },
    {
        path: 'trendlines/van/national-rates',
        component: IqBuilderDashboardComponent,
        data: { dashboard: VanNational },
    },
    {
        path: 'trendlines/reefer/demand-and-capacity',
        component: IqBuilderDashboardComponent,
        data: { dashboard: ReeferDemand },
    },
    {
        path: 'trendlines/reefer/national-rates',
        component: IqBuilderDashboardComponent,
        data: { dashboard: ReeferNational },
    },
    {
        path: 'trendlines/flatbed/demand-and-capacity',
        component: IqBuilderDashboardComponent,
        data: { dashboard: FlatbedDemand },
    },
    {
        path: 'trendlines/flatbed/national-rates',
        component: IqBuilderDashboardComponent,
        data: { dashboard: FlatbedNational },
    },
    {
        path: 'trendlines/carrier-resources',
        component: IqCarrierResourcesDashboardComponent
    },
    {
        path: '**',
        redirectTo: 'trendlines',
    },
];
